export var createEventTargetConstructor = function (createEventTarget, wrapEventListener) {
    return /** @class */ (function () {
        function EventTarget(nativeEventTarget) {
            if (nativeEventTarget === void 0) { nativeEventTarget = null; }
            this._listeners = new WeakMap();
            this._nativeEventTarget = nativeEventTarget === null ? createEventTarget() : nativeEventTarget;
        }
        EventTarget.prototype.addEventListener = function (type, listener, options) {
            if (listener !== null) {
                var wrappedEventListener = this._listeners.get(listener);
                if (wrappedEventListener === undefined) {
                    wrappedEventListener = wrapEventListener(this, listener);
                    if (typeof listener === 'function') {
                        this._listeners.set(listener, wrappedEventListener);
                    }
                }
                this._nativeEventTarget.addEventListener(type, wrappedEventListener, options);
            }
        };
        EventTarget.prototype.dispatchEvent = function (event) {
            return this._nativeEventTarget.dispatchEvent(event);
        };
        EventTarget.prototype.removeEventListener = function (type, listener, options) {
            var wrappedEventListener = listener === null ? undefined : this._listeners.get(listener);
            this._nativeEventTarget.removeEventListener(type, wrappedEventListener === undefined ? null : wrappedEventListener, options);
        };
        return EventTarget;
    }());
};
//# sourceMappingURL=event-target-constructor.js.map
